export default __webpack_public_path__ + "static/media/Manutd.bef4b10e.png";